import { Box, Typography } from "@mui/material";
import React from "react";

import { getRatingColor } from "../common/colors";

export type RatingValue = "Excellent" | "Exceptional" | "Above Expectations" | "Meets Expectations" | "Below Expectations" | "Poor";

export interface RatingProps {
  rating: RatingValue;
}

const getRatingBars = (rating: RatingValue): number => {
  const barMap: Record<RatingValue, number> = {
    Excellent: 5,
    Exceptional: 5,
    "Above Expectations": 4,
    "Meets Expectations": 3,
    "Below Expectations": 2,
    Poor: 1
  };

  return barMap[rating];
};

export const RatingIndicator: React.FC<RatingProps> = ({ rating }) => {
  const bars = getRatingBars(rating);
  const color = getRatingColor(rating);

  return (
    <Box display="flex" alignItems="center">
      {[...Array(5)].map((_, i) => (
        <Box
          key={i}
          width={8}
          height={16}
          bgcolor={i < bars ? color : "#e0e0e0"}
          mx={0.25}
        />
      ))}
      <Typography variant="caption" ml={1} color="text.secondary">
        {rating}
      </Typography>
    </Box>
  );
};

export default RatingIndicator;
